import { SessionError } from '../login/Session'

export const incorrectPasswordCounter = (sessionError: SessionError): boolean => {
  return !!sessionError?.info?.missing_attempts
}

export const userIsBlocked = (sessionError: SessionError): boolean => {
  return !!sessionError?.info?.email
}
